export default __webpack_public_path__ + "static/media/Charles Paz Resume.pdf";